import { React, useState, useEffect } from 'react';
import './style.css';
import Loader from "../../components/loader/Loader";
import { getDashboard } from '../../../services/Admin';

function Dashboard() {
  const [isLoading, setIsLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState({
    users: {
      total: 0,
      newToday: 0,
      active: 0
    },
    packages: {
      total: 0,
      newToday: 0,
      active: 0
    },
    investments: {
      total: 0,
      today: 0
    },
    withdrawals: {
      total: 0
    }
  });

  const cardColors = [
    'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)',
    'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)',
    'linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)',
    'linear-gradient(135deg, #ffc3a0 0%, #ffafbd 100%)',
    'linear-gradient(135deg, #a6c1ee 0%, #fbc2eb 100%)',
    'linear-gradient(135deg, #d4fc79 0%, #96e6a1 100%)'
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getDashboard();
        if (response && response.data) {
          setDashboardData(response.data);
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <h1 className="main-heading">Dashboard</h1>
          <br />
          <br />
          <div className='admin-dashboard'>
            {/* Users Section */}
            <div className='ad-da-first'>
              <div className='ad-fa-fi-item' style={{background: cardColors[0]}}>
                <h2>Total Users</h2>
                <h1>{dashboardData.users.total}</h1>
              </div>
            </div>
            <br />
            <div className='ad-da-first'>
              <div className='ad-fa-fi-item' style={{background: cardColors[1]}}>
                <h2>Active Users</h2>
                <h1>{dashboardData.users.active}</h1>
              </div>
            </div>
            <br />
            <div className='ad-da-first'>
              <div className='ad-fa-fi-item' style={{background: cardColors[2]}}>
                <h2>New Users Today</h2>
                <h1>{dashboardData.users.newToday}</h1>
              </div>
            </div>
            
            {/* Packages Section */}
            <br />
            <div className='ad-da-first'>
              <div className='ad-fa-fi-item' style={{background: cardColors[3]}}>
                <h2>Total Packages</h2>
                <h1>{dashboardData.packages.total}</h1>
              </div>
            </div>
            <br />
            <div className='ad-da-first'>
              <div className='ad-fa-fi-item' style={{background: cardColors[4]}}>
                <h2>Active Packages</h2>
                <h1>{dashboardData.packages.active}</h1>
              </div>
            </div>
            <br />
            <div className='ad-da-first'>
              <div className='ad-fa-fi-item' style={{background: cardColors[5]}}>
                <h2>New Packages Today</h2>
                <h1>{dashboardData.packages.newToday}</h1>
              </div>
            </div>
            
            {/* Investments Section */}
            <br />
            <div className='ad-da-first'>
              <div className='ad-fa-fi-item' style={{background: cardColors[0]}}>
                <h2>Total Investments</h2>
                <h1>${dashboardData.investments.total.toFixed(2)}</h1>
              </div>
            </div>
            <br />
            <div className='ad-da-first'>
              <div className='ad-fa-fi-item' style={{background: cardColors[1]}}>
                <h2>Today's Investments</h2>
                <h1>${dashboardData.investments.today.toFixed(2)}</h1>
              </div>
            </div>
            
            {/* Withdrawals Section */}
            <br />
            <div className='ad-da-first'>
              <div className='ad-fa-fi-item' style={{background: cardColors[2]}}>
                <h2>Total Withdrawals</h2>
                <h1>${dashboardData.withdrawals.total.toFixed(2)}</h1>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Dashboard;